import {
  veloDependenciesConfigSchema,
  getVeloDependenciesConfigPath,
  VELO_DEPENDENCIES_CONFIG_PATH,
} from '@wix/cli-site-old-definitions';
import { readJson } from '@wix/cli-fs';
import { CliError, CliErrorCode } from '@wix/cli-error';

export async function loadDependenciesConfig(projectFolder: string) {
  const configFile = await readJson(
    getVeloDependenciesConfigPath(projectFolder)
  );

  try {
    return veloDependenciesConfigSchema.parse(configFile);
  } catch (e) {
    throw new CliError({
      code: CliErrorCode.InvalidVeloConfigJson({
        configFilename: VELO_DEPENDENCIES_CONFIG_PATH,
      }),
      cause: e,
    });
  }
}
